import YachtDescription from './YachtDescription';

export default YachtDescription;
